import React from "react";

import StyledPatientsDetails from "./StyledPatientsDetails";

const PatientsDetails = ({ patientsDetails }) => {
  return (
    <StyledPatientsDetails>
      <div className="container total-patients">
        <div className="row">
          <div className="col">
            <div className="font-size-18 aqua-deep">Total Patients</div>
            <div className="font-size-30 bold aqua-deep">
              {patientsDetails?.all_patients}
            </div>
          </div>
          <div className="col">
            <div className="font-size-18 aqua-deep">Active Patients</div>
            <div className="font-size-30 bold aqua-deep">
              {patientsDetails?.active_patients}
            </div>
          </div>
          <div className="col">
            <div className="font-size-18 aqua-deep">Expired PAF</div>
            <div className="font-size-30 bold aqua-deep">
              {patientsDetails?.overdue_paf}
            </div>
          </div>
          <div className="col">
            <div className="font-size-18 aqua-deep">Rejected PAF</div>
            <div className="font-size-30 bold aqua-deep">
              {patientsDetails?.rejected_paf}
            </div>
          </div>
        </div>
      </div>
    </StyledPatientsDetails>
  );
};
export default PatientsDetails;
